module.exports = __webpack_public_path__ + "img/35_37.727167bd.png";